<template src="../../../../components/shared/physicianSearch/BaseSearchBoxV2.html"></template>

<script>
	import {searchFiltersMixin} from "../../../../components/shared/mixins/searchFiltersMixin.js";
	import {searchBoxMixinV2} from "../../../../components/shared/mixins/searchBoxMixinV2.js";
	import {common} from "../../../../global/common.js";
	import {enrollmentPlanCategoryMixin} from "../../mixins/enrollmentPlanCategoryMixin.js";
	import PlanCategoryButtons from "../../../../components/shared/physicianSearch/PlanCategoryButtons.vue";

	export default {
		name: "SearchBox",
		components: {PlanCategoryButtons},
		props: {
			radiusId: {type: [Number], required: true},
			companyId: {type: [Number], required: true},
			token: {type: [String], required: true},
		},
		mixins: [searchFiltersMixin, searchBoxMixinV2, enrollmentPlanCategoryMixin],
		data() {
			return {
				entityId: this.consumerId,
				showPlanCategories: true,
				consultantId: null,
				largeSearchToolbar: false
			}
		},
		async mounted() {
			await this.baseInit();
			let networksUrl = `providerSearch/${this.companyId}/GetAvailableNetworks`;
			networksUrl = common.appendUrlParameter(networksUrl, 'token', this.token);
			let [bi, an] = await Promise.all([this.enrollmentFilterInit(),
				$.ajax({type: "GET", url: networksUrl})]);
			this.availableNetworks = an;
		},
		methods: {
			shouldRunSearch() {
				const hasSelectedCategory = this.searchCriteria.planCategoryId !== null
					&& typeof this.searchCriteria.planCategoryId !== 'undefined'
					&& this.searchCriteria.planCategoryId !== '';
				return this.hasSearchCriteria && hasSelectedCategory;
			},
			async enrollmentFilterInit() {
				await Promise.all([this.baseLoad(), this.setCurrentCriteria()]);
				if (this.shouldRunSearch()) {
					await this.searchEnrollmentPhysicians();
				}
			},
            openModal() {
                $(this.$refs.topContainer).modal('show');
            },
			generateBaseUrl() {
				let url = `providerSearch/${this.companyId}/byLocation/${this.searchCriteria.latitude}/${this.searchCriteria.longitude}/${this.searchCriteria.radiusId}`;
				url = common.appendUrlParameter(url, 'token', this.token);
				return url;
			},
			async searchPhysiciansRedirect() {
                $(this.$refs.topContainer).modal('hide');
				this.$router.push({
					name: "search", params: {
						companyId: this.companyId,
						token: this.token,
						latitude: this.searchCriteria.latitude,
						longitude: this.searchCriteria.longitude,
						radiusId: this.searchCriteria.radiusId,
					},
					query: {
						designationId: this.searchCriteria.designationId,
						//Have to do this because keep in mind that Boolean('false') = true
						onlyAcceptingNewPatients: this.searchCriteria.onlyAcceptingNewPatients ? 1 : 0,
						physicianName: this.searchCriteria.physicianName,
						addressName: this.searchCriteria.addressName,
						networkId: this.searchCriteria.networkId,
						planCategoryId: this.searchCriteria.planCategoryId
					}
				});
			}
		},
		watch: {
			$route(to, from) {
				if (to.name === "search") {
					this.setCurrentCriteria().then(() => this.searchEnrollmentPhysicians());
				}
			}
		},
	}
</script>

<style scoped src="../../../../components/shared/physicianSearch/BaseSearchBoxV2.css">

</style>
<style scoped>

</style>